import { createRoute } from "@tanstack/react-router";
import { AuthGuard } from "@/components/auth/AuthGuard";
import { ClientsRegistry } from "@/pages/registries/ClientsRegistry";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/clients",
  component: ClientsRoute,
});

function ClientsRoute() {
  return (
    <AuthGuard>
      <ClientsRegistry />
    </AuthGuard>
  );
}
